export default __webpack_public_path__ + "static/media/trell.8ab6f233.png";